module.exports = __webpack_public_path__ + "img/svg/faq-separator-mobile.b714c1f24870d15896bd1a01113667e2.svg";